import { Box, Grid, Typography } from '@material-ui/core';
import SlideFrame, { ContestantHeading } from './SlideFrame';
import HeatGrid from './HeatGrid';
import BarList from '../tournament/participant/BarList';
import { ACCEPTED_COLOR, REJECTED_COLOR } from '../tournament/participant/palette';
import verdictLabel from '../../utils/verdictLabels';

// What the two contestants' submissions came back as, and which cells of the
// board they have been taking.
function VerdictGridSlide(props) {
    const sides = [
        { name: props.contestant1, statistics: props.statistics1 },
        { name: props.contestant2, statistics: props.statistics2 }
    ];
    return (
        <SlideFrame eyebrow={props.tournamentName} matchLabel={props.matchLabel} title='Verdicts and Grid Distribution'>
            <Grid container spacing={6}>
                {sides.map((side, index) => (
                    <Grid item xs={6} key={index}>
                        <ContestantHeading contestant={index} name={side.name} />
                        {side.statistics == null ?
                            <Typography color='textSecondary' align='center'> No statistics </Typography> :
                            <>
                                <Box maxWidth={520} margin='0 auto'>
                                    <BarList
                                        large
                                        emptyMessage='No submission judged yet'
                                        items={(side.statistics.verdicts ?? []).slice(0, 5).map(verdict => ({
                                            key: verdict.verdict,
                                            label: verdictLabel(verdict.verdict),
                                            value: verdict.count,
                                            valueLabel: `${verdict.count} · ${verdict.percentage.toFixed(1)}%`,
                                            color: verdict.verdict === 'OK' ? ACCEPTED_COLOR : REJECTED_COLOR
                                        }))}
                                    />
                                </Box>
                                <Box mt={3}>
                                    <HeatGrid grid={side.statistics.grid} />
                                </Box>
                            </>
                        }
                    </Grid>
                ))}
            </Grid>
        </SlideFrame>
    );
}

export default VerdictGridSlide;
